import React, { useEffect, useRef } from 'react';
import { useToaster, InputGroup, Button, Input, Panel, Grid, Row, Col, Divider } from 'rsuite';
import "rsuite/dist/rsuite-rtl.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import * as BiIcon from "react-icons/bi";
import * as General from '../General/General';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

const LoginIndex = () => {

    //#region Const 
    const toaster = useToaster();
    let navigate = useNavigate();
    const [UserName, setUserName] = React.useState("");
    const [PassWord, setPassWord] = React.useState("");
    const [visible, setVisible] = React.useState(false);
    const [LoginText, setLoginText] = useState('ورود  ');
    const [LoginDisabled, setLoginDisabled] = useState(false);
    //#endregion

    //#region Handlres

    const UserName_Change = e => {
        setUserName(e);
    }

    const Password_Change = e => {
        setPassWord(e);
    }

    const Visible_Change = () => {
        setVisible(!visible);
    };
    //#endregion

    //#region Methods




    const Login = () => {
        if (UserName == "" || PassWord == "") {
            toaster.push(General.ShowMessage('error', "لطفا ! نام کاربری یا کلمه عبور را وارد نمایید"), 'topCenter')

        }
        var MyHeader = new Headers();
        MyHeader.append("ApiKey", General.APIKey());
        MyHeader.append("UserName", UserName);
        MyHeader.append("PassWord", PassWord);

        var requestOptions = {
            headers: MyHeader,
            method: "Post",
            credentials: 'include'
        };

        setLoginText("لطفاً منتظر بمانید ... ");
        setLoginDisabled(true);
        //trackPromise(
        fetch(General.ApiRoute() + "/User/Login", requestOptions)
            .then(Response => Response.json())
            .then(result => {
                if (result.result == "OK") {
                    localStorage.setItem("UserFullName", result.fullName)
                    localStorage.setItem("UserId", result.id)
                    localStorage.setItem("UserName", result.userName)
                    localStorage.setItem("FiscalYearId", 1)
                    localStorage.setItem("ShowBuyPrice", result.ShowBuyPrice)
                    navigate("/Dashboard")
                }
                else {
                    setLoginDisabled(false);
                    setLoginText("ورود ");
                    toaster.push(General.ShowMessage('error', result.result), 'topCenter')
                }
            }).catch((error) => {

                console.dir(error)
                setLoginDisabled(false);
                setLoginText("ورود ");
                toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
            })
        //)
    }




    const LoginKeyDown = (e) => {
        if (e.key === 'Enter') {
            Login();
        }
    }


    //#endregion
    return (

        <Grid fluid onKeyUp={LoginKeyDown} className='bg-white h-100vh'>
            <Row>
                <Col xxl={24} xl={24} md={24} sm={24} xs={24} className="FarmAsan-success h-30vh d-flex flex-column align-items-center justify-content-center text-white p-5" >


                    <div className='mt-3 Font17 font-weight-bold text-center'>
                        FarmAsan
                        <br />
                        v e r s i o n : 1.0.0.0
                    </div>

                </Col>
                <Col xxl={4} xl={4} md={4} sm={4} xs={4} >


                    

                </Col>
                <Col xxl={16} xl={16} md={16} sm={16} xs={16} className="Login_Margin shadow  mb-5 bg-white rounded bg-white h-60vh d-flex align-items-center justify-content-center p-5 " >

                    <Panel className="bg-white w-75" >


                        <div className="mt-4">
                            <label>نام کــاربری</label>
                            <Input value={UserName} onChange={UserName_Change} />
                            <label>کلمه عبــور</label>
                            <InputGroup inside >
                                <Input value={PassWord} onChange={Password_Change} type={visible ? 'text' : 'password'} />
                                <InputGroup.Button onClick={Visible_Change}>
                                    {visible ? <BiIcon.BiHide /> : <BiIcon.BiShow />}
                                </InputGroup.Button>
                            </InputGroup>
                            <Button appearance="primary" color="red" className="mt-1 " onClick={Login} > <BiIcon.BiLockOpen size={20} disabled={LoginDisabled} /> {LoginText}</Button>

                        </div>
                        <div className="text-center Logo">

                            <img src="../../assets/images/Logo.png" style={{ width: 80 }} />
                        </div>
                    </Panel>
                </Col>

            </Row>
        </Grid>


    )
}

export default LoginIndex;